<template>
    <modal-ui :id="id" :title="$t(state.title)">
        <form class="loader" @submit.prevent="formHandler">
            <loader-ui :is-show="state.loader" />
            <div v-if="state.step === 1" class="row">
                <div class="col-12">
                    <div class="alert alert-info">
                        <div class="alert-message">
                            Шаг 1: Заполните все необходимые поля студента
                        </div>
                    </div>
                </div>
                <div v-if="entrances.length !== 1" class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Выберите общежитие" label="Общежитие" required>
                        <select-ui :is-invalid="state.step1.visibleErrors && isEntranceIdError" :options="entrances"
                            placeholder="Общежитие" :searchable="true" :values="[state.step1.entranceId]"
                            @on-selected="onSelectedEntrance" />
                    </form-group-ui>
                </div>
                <div class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Укажите фамилию" label="Фамилия" :required="true">
                        <input-ui v-model="state.step1.lastName"
                            :is-invalid="state.step1.visibleErrors && isLastNameError" placeholder="Фамилия" />
                    </form-group-ui>
                </div>
                <div class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Укажите имя" label="Имя" :required="true">
                        <input-ui v-model="state.step1.firstName"
                            :is-invalid="state.step1.visibleErrors && isFirstNameError" placeholder="Имя" />
                    </form-group-ui>
                </div>
                <div class="col-12 col-lg-6">
                    <form-group-ui label="Отчество">
                        <input-ui v-model="state.step1.middleName" placeholder="Отчество" />
                    </form-group-ui>
                </div>
                <div class="col-12 col-lg-6">
                    <form-group-ui 
                        :invalid-feedback="iinInvalidFeedback" 
                        label="ИИН" 
                        :required="true"
                    >
                        <input-ui
                        v-model="state.step1.iin"
                        :is-invalid="state.step1.visibleErrors && (isIinError || isHumanExist)"
                        :mask="{ mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ } } }"
                        maxlength="12"
                        minlength="12"
                        placeholder="ИИН"
                        />
                    </form-group-ui>
                </div>

                <div class="col-12 col-lg-6">
                    <form-group-ui :invalid-feedback="phoneInvalidFeedback" label="Номер телефона" :required="isPhoneRequired">
                        <input-ui
                            v-model="state.step1.phone"
                            :is-invalid="state.step1.visibleErrors && isPhoneError"
                            :mask="'+7 (###) ### ## ##'"
                            placeholder="+7 (000) 000 00 00" />
                    </form-group-ui>
                </div>
                <div class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Выберите тип" label="Тип" required>
                        <select-ui
                            :is-invalid="state.step1.visibleErrors && isRoleIdError"
                            :options="humanRolesFiltered"
                            placeholder="Тип"
                            :searchable="true"
                            :values="[state.step1.roleId]"
                            @on-selected="onSelectedRole" />
                    </form-group-ui>
                </div>
                <div v-if="state.step1.roleId === 1" class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Выберите учебное заведение" label="Учебное заведение" required>
                        <select-ui :disabled="state.step1.roleId !== 1"
                            :is-invalid="state.step1.visibleErrors && isInstitutionIdError" :options="institutions"
                            placeholder="Учебное заведение" :searchable="true" :values="[state.step1.prop1]"
                            @on-selected="onSelectedInstitution">
                            <template #option="props">
                                {{ props.option.type === 'college' ? 'Колледж -' : 'Университет -' }} {{
                                props.option.name }}
                            </template>
                        </select-ui>
                    </form-group-ui>
                </div>
                <div v-if="state.step1.roleId === 1 && typeof getInstitution !== 'undefined' && getInstitution?.type !== 'college'"
                    class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Выберите форму обучения" label="Форма обучения" required>
                        <select-ui :disabled="state.step1.roleId !== 1"
                            :is-invalid="state.step1.visibleErrors && isEducationIdError" :options="educations"
                            placeholder="Форма обучения" :searchable="true" :values="[state.step1.prop2]"
                            @on-selected="onSelectedEducation" />
                    </form-group-ui>
                </div>
                <div v-if="state.step1.roleId === 1" class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Выберите дату поступления" label="Дата поступления" required>
                        <date-picker timezone="UTC" v-model="state.step1.enteredAt" class="inline-block h-full"
                            :is24hr="true" mode="date">
                            <template #default="{ inputValue, togglePopover }">
                                <div class="flex items-center">
                                    <input class="form-control"
                                        :class="{ 'is-invalid': isEnteredAtError && state.step1.visibleErrors, 'bg-white': state.step1.roleId === 1 }"
                                        :disabled="state.step1.roleId !== 1" placeholder="Дата поступления" readonly
                                        :timezone="'Asia/Qyzylorda'" :value="inputValue" @blur="togglePopover()"
                                        @focus="togglePopover()">
                                    <div class="invalid-feedback">
                                        Укажите дату
                                    </div>
                                </div>
                            </template>
                        </date-picker>
                    </form-group-ui>
                </div>
                <div v-if="state.step1.roleId === 1" class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Укажите номер комнаты" label="Номер комнаты">
                        <input-ui v-model="state.step1.roomNumber" :disabled="state.step1.roleId !== 1"
                            :is-invalid="state.step1.visibleErrors && isRoomNumberError" placeholder="Номер комнаты" />
                    </form-group-ui>
                </div>
                <div v-if="state.step1.roleId === 1" class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Укажите курс обучения" label="Курс обучения" :required="true">
                        <input-ui v-model="state.step1.courseNumber" :disabled="state.step1.roleId !== 1"
                            :is-invalid="state.step1.visibleErrors && isCourseNumberError"
                            :mask="{ mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ } } }" maxlength="1"
                            placeholder="Курс обучения" />
                    </form-group-ui>
                </div>
                <div v-if="state.step1.roleId === 1" class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Укажите номер договора" label="Номер договора">
                        <input-ui v-model="state.step1.contractNumber" :disabled="state.step1.roleId !== 1"
                            :is-invalid="state.step1.visibleErrors && isContractNumberError"
                            placeholder="Номер договора" />
                    </form-group-ui>
                </div>
                <div v-if="state.step1.roleId === 1" class="col-12 col-lg-6">
                    <form-group-ui invalid-feedback="Выберите дату заключения договора" label="Дата заключения договора"
                        required>
                        <date-picker timezone="UTC" v-model="state.step1.contractDate" class="inline-block h-full"
                            :is24hr="true" mode="date">
                            <template #default="{ inputValue, togglePopover }">
                                <div class="flex items-center">
                                    <input class="form-control"
                                        :class="{ 'is-invalid': isContractDateError && state.step1.visibleErrors, 'bg-white': state.step1.roleId === 1 }"
                                        :disabled="state.step1.roleId !== 1" placeholder="Дата заключения договора"
                                        readonly :timezone="'Asia/Qyzylorda'" :value="inputValue"
                                        @blur="togglePopover()" @focus="togglePopover()">
                                    <div class="invalid-feedback">
                                        Укажите дату
                                    </div>
                                </div>
                            </template>
                        </date-picker>
                    </form-group-ui>
                </div>
                <div v-if="isCapacityError" class="col-12 mt-2">
                    <div class="alert alert-danger">
                        <div class="alert-message text-center">
                            Превышено число вместимости студентов в общежитие
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center pt-2">
                    <button-ui button-class="btn-primary">
                        {{ isFinalStep ? 'Сохранить' : $t(state.btn) }}
                    </button-ui>
                </div>
            </div>
            <div v-if="state.step === 5" class="row">
                <div class="col-12">
                    <div class="alert alert-info">
                        <div class="alert-message">
                            Шаг 2: Загрузите документы в формате JPG, JPEG, PNG или PDF
                            <br><small class="text-danger"><strong>Максимальный размер файла: 2MB</strong></small>
                        </div>
                    </div>
                </div>
                <!--
                <div class="col-12 col-lg-6">
                    <div class="mb-3">
                        <label class="form-label w-100">
                            Договор найма жилого помещения
                        </label>
                        <input ref="file1" :class="{ 'is-invalid': state.step5.visibleErrors && isFile1Error }"
                            type="file" @change="selectFile($event, 'file1')">
                        <div class="invalid-feedback">
                            Выберите документ
                        </div>
                    </div>
                </div>
                -->
                <div class="col-12 col-lg-6">
                    <div class="mb-3">
                        <label class="form-label w-100">
                            Документ, удостоверяющий личность
                        </label>
                        <input ref="file2" :class="{ 'is-invalid': state.step5.visibleErrors && isFile2Error }"
                            type="file" @change="selectFile($event, 'file2')">
                        <div class="invalid-feedback">
                            Выберите документ
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="mb-3">
                        <label class="form-label w-100">
                            Документ, подтверждающий обучение в организации образования
                        </label>
                        <input ref="file3" :class="{ 'is-invalid': state.step5.visibleErrors && isFile3Error }"
                            type="file" @change="selectFile($event, 'file3')">
                        <div class="invalid-feedback">
                            Выберите документ
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center pt-2">
                    <button-ui class="btn-outline-primary" @click="backStep">
                        Назад
                    </button-ui>
                    <button-ui button-class="btn-primary ms-3">
                        {{ isFinalStep ? 'Сохранить' : $t(state.btn) }}
                    </button-ui>
                </div>
            </div>
            <div v-if="state.step === 6" class="row">
                <div class="col-12">
                    <div class="alert alert-info">
                        <div class="alert-message">
                            Шаг {{ state.step1.roleId === 1 ? 3 : 2 }}: Отсканируйте карточку через считыватель несколько раз, для проверки карточки
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <form-group-ui :invalid-feedback="'Коды не совпадают'" label="Первое сканирование">
                        <input-ui v-model="state.step6.code1" :is-invalid="isCodesError" />
                    </form-group-ui>
                </div>
                <div class="col-12 col-lg-6">
                    <form-group-ui :invalid-feedback="'Коды не совпадают'" label="Второе сканирование">
                        <input-ui v-model="state.step6.code2" :is-invalid="isCodesError" />
                    </form-group-ui>
                </div>
                <div class="col-12 text-center">
                    <button-ui v-if="state.type === 'add'" class="btn-outline-primary" @click="backStep">
                        Назад
                    </button-ui>
                    <button-ui button-class="btn-primary ms-3"
                        :disabled="isCodesError || !state.step6.code1.length || !state.step6.code2.length">
                        {{ $t(state.btn) }}
                    </button-ui>
                </div>
            </div>
        </form>
    </modal-ui>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, reactive, computed, ref, watch, watchEffect, h } from "vue";
import { initModal, isOpen, useModal } from "@/composables/useModal";
import api from "@/api";
import { ICity } from "@/@types/cities";
import { useDevicesList, useUserMedia } from '@vueuse/core';
import CameraComponent from "@/components/CameraComponent.vue";
import { socketOn, socketOff } from "@/composables/useSocket";
import { useDocumentFiles } from "@/composables/useDocumentFiles";
import jsonToFormData from '@ajoelp/json-to-formdata';
import { DatePicker } from 'v-calendar';
import moment from "moment";

export default defineComponent({
    name: "HumanAEModal",
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    components: {
        DatePicker,
    },
    setup(props) {
        const modal = useModal(props.id);

        const formatKzPhone = (value: any): string => {
            const raw = value == null ? '' : String(value);
            const digits = raw.replace(/\D/g, '');
            if (!digits) return '';

            let d = digits;
            // 8707xxxxxxx -> 7707xxxxxxx
            if (d.length === 11 && d.startsWith('8')) d = '7' + d.slice(1);
            // 707xxxxxxx -> 7707xxxxxxx
            if (d.length === 10) d = '7' + d;

            if (d.length !== 11 || !d.startsWith('7')) return raw;

            return `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)} ${d.slice(7, 9)} ${d.slice(9, 11)}`;
        };

        const parseDateValue = (value: any) => {
            if (!value) return null;
            const date = value instanceof Date ? value : new Date(value);
            return isNaN(date.getTime()) ? null : date;
        };

        const state = reactive({
            title: '',
            btn: '',
            step: 1,
            loader: false,
            type: 'add',
            id: 0,
            step1: {
                entranceId: 0,
                firstName: '',
                lastName: '',
                middleName: '',
                roleId: 0,
                iin: '',
                phone: '',
                prop1: 0,
                prop2: 0,
                enteredAt: null,
                roomNumber: '',
                courseNumber: 0,
                contractNumber: '',
                contractDate: null,
                humanExist: false,
                humanExistError: '',
                visibleErrors: false,
            },
            step5: {
                file1: null,
                file2: null,
                file3: null,
                visibleErrors: false,
            },
            step6: {
                code1: '',
                code2: '',
                lastCode: 0,
            },
        });

        const entrances = ref([]);
        const universities = ref([]);
        const institutions = ref([]);
        const educations = ref([]);
        const humanRoles = ref([]);
        const { file1, file2, file3, selectFile } = useDocumentFiles(state.step5);

        /** При редактировании: у студента можно выбрать и «Студент», и «Сотрудник», у сотрудника — только роли сотрудников (без «Студент»). */
        const humanRolesFiltered = computed(() => {
            const list = humanRoles.value || [];
            const seen = new Set<string>();
            const unique = list.filter((r: any) => {
                const key = String(r.alias || r.name || r.id).toLowerCase();
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });

            if (state.type !== 'edit') return unique;
            const currentRoleId = state.step1.roleId;
            // Студент -> можно выбрать любую роль
            if (currentRoleId === 1) return unique;
            // Сотрудник -> нельзя менять на студента
            return unique.filter((r: any) => r.id !== 1);
        });

        const getInstitution = computed(() => institutions.value.find((i: any) => i.id === state.step1.prop1));

        const isEntranceIdError = computed(() => !state.step1.entranceId);
        const isUniversityIdError = computed(() => state.step1.roleId === 1 && !state.step1.prop1);
        const isInstitutionIdError = computed(() => state.step1.roleId === 1 && !state.step1.prop1);
        const isEducationIdError = computed(() => state.step1.roleId === 1 && !state.step1.prop2);
        const isRoleIdError = computed(() => !state.step1.roleId);
        const isFirstNameError = computed(() => !state.step1.firstName.length);
        const isLastNameError = computed(() => !state.step1.lastName.length);
        const isIinError = computed(() => {
        const iin = state.step1.iin;
        return !(iin && iin.length === 12 && /^\d{12}$/.test(iin));
        });        

        const isPhoneRequired = computed(() => state.type === 'add');
        const phoneDigits = computed(() => String(state.step1.phone || '').replace(/\D/g, ''));
        const normalizedPhoneDigits = computed(() => {
            // Приводим к формату 7XXXXXXXXXX
            const d = phoneDigits.value;
            if (!d) return '';
            // 2323232233 -> 72323232233
            if (d.length === 10) return `7${d}`;
            // 8727... -> 7727...
            if (d.length === 11 && d.startsWith('8')) return `7${d.slice(1)}`;
            // 7727... (или любые 11 цифр, начинающиеся с 7) оставляем как есть
            if (d.length === 11 && d.startsWith('7')) return d;
            return d;
        });
        const isPhoneError = computed(() => {
            // При редактировании телефон не обязателен: валидируем только если заполнен
            if (!isPhoneRequired.value && !phoneDigits.value.length) return false;
            const n = normalizedPhoneDigits.value;
            return !(n.length === 11 && n.startsWith('7'));
        });
        const phoneInvalidFeedback = computed(() => {
            if (!phoneDigits.value.length) return isPhoneRequired.value ? 'Укажите номер телефона' : 'Укажите номер телефона';
            return 'Укажите корректный номер телефона';
        });
        const isEnteredAtError = computed(() => state.step1.roleId === 1 && !state.step1.enteredAt);
        // const isFile1Error = computed(() => state.step5.file1 === null);
        const isFile1Error = computed(() => false);
        const isFile2Error = computed(() => state.step5.file2 === null);
        const isFile3Error = computed(() => state.step5.file3 === null);
        const isRoomNumberError = computed(() => !state.step1.roomNumber.length);
        const isCourseNumberError = computed(() => !state.step1.courseNumber);
        const isContractNumberError = computed(() => !state.step1.contractNumber.length);
        const isContractDateError = computed(() => !state.step1.contractDate);
        const isCodesError = computed(() => state.step6.code1.length && state.step6.code2.length && state.step6.code1 !== state.step6.code2);
        const isHumanExist = computed(() => state.step1.humanExist);
        const isHumanExistError = computed(() => state.step1.humanExistError);

        // Финальное сообщение для invalid-feedback
        const iinInvalidFeedback = computed(() => {
        if (isHumanExist.value) return isHumanExistError.value;
        return 'Укажите корректный ИИН';
        });

        const selectedEntranceHasFaceId = computed(() => {
            const entrance: any = entrances.value.find((i: any) => i.id === state.step1.entranceId);
            return Boolean(Number(entrance?.hasFaceId));
        });

        // В общежитии с Face ID студент проходит по лицу — шаг сканирования карточки пропускаем
        const skipCardStep = computed(() => state.type === 'add' && selectedEntranceHasFaceId.value);

        const isFinalStep = computed(() => {
            if (!skipCardStep.value) return false;
            if (state.step === 1) return Boolean(state.step1.roleId) && state.step1.roleId !== 1;
            return state.step === 5;
        });

        const isCapacityError = computed(() => {
            // Показываем только после выбора типа «Студент» — сотрудники по ПМ не блокируются
            if (state.step1.roleId !== 1 || !state.step1.entranceId) {
                return false;
            }
            const entrance: any = entrances.value.find((i: any) => i.id === state.step1.entranceId);
            if (!entrance) {
                return false;
            }
            return Number(entrance.capacity) <= Number(entrance.humansCount);
        });


        watchEffect(() => {
            console.log('state.type:', state.type);
        });

        const errors = computed(() => {
            if (!state.step1.roleId) {
                return isRoleIdError.value
                    || isFirstNameError.value
                    || isLastNameError.value
                    || isEntranceIdError.value
                    || isIinError.value
                    || isPhoneError.value;
            }
            if (state.step1.roleId === 1) {
                // @ts-ignore
                return isHumanExist.value || isCapacityError.value || isFirstNameError.value || isLastNameError.value || isEntranceIdError.value || isIinError.value || isPhoneError.value || isInstitutionIdError.value || isEnteredAtError.value || isRoomNumberError.value || isCourseNumberError.value || isContractNumberError.value || isContractDateError.value || (getInstitution.value?.type !== 'college' && isEducationIdError.value);
            } else {
                return isFirstNameError.value || isLastNameError.value || isEntranceIdError.value || isIinError.value || isPhoneError.value;
            }
        });

        onMounted((() => {
            // state.title = 'modals.turnstile.titleAdd';
            state.title = '';
            // state.btn = 'modals.turnstile.btnAdd';
            state.btn = 'Далее';

            api.v1.info.entrances.get().then((r: any) => {
                entrances.value = r.data.data;
                if (r.data.data.length == 1) {
                    state.step1.entranceId = r.data.data[0].id;
                }
            });

            api.v1.info.universities.get().then((r: any) => {
                universities.value = r.data.data;
            });

            api.v1.info.institutions.get().then((r: any) => {
                institutions.value = r.data.data;
            });

            api.v1.info.educations.get().then((r: any) => {
                educations.value = r.data.data;
            });

            api.v1.info.humanRoles.get().then((r: any) => {
                humanRoles.value = r.data.data;
            });

            if (modal.data.hasOwnProperty('human')) {
                if (modal.data.type === 'edit') {
                    state.title = 'Редактирование студента';
                    state.type = 'edit';
                    state.id = modal.data.human.id;
                    state.step1.firstName = modal.data.human.firstName;
                    state.step1.lastName = modal.data.human.lastName;
                    state.step1.middleName = modal.data.human.middleName ? modal.data.human.middleName : '';
                    state.step1.iin = modal.data.human.iin;
                    state.step1.entranceId = modal.data.human.entranceId;
                    state.step1.roleId = modal.data.human.roleId;
                    state.step1.prop1 = modal.data.human.prop1;
                    state.step1.prop2 = modal.data.human.prop2;
                    state.step1.enteredAt = parseDateValue(modal.data.human.enteredAt);
                    state.step1.roomNumber = modal.data.human.roomNumber;
                    state.step1.courseNumber = modal.data.human.courseNumber;
                    state.step1.contractNumber = modal.data.human.contractNumber;
                    state.step1.contractDate = parseDateValue(modal.data.human.contractDate);
                    state.step1.phone = formatKzPhone(modal.data.human.phone);
                    // state.step5.file1 = modal.data.human.fileOne;
                    state.step5.file2 = modal.data.human.fileTwo;
                    state.step5.file3 = modal.data.human.fileThree;
                }
                if (modal.data.type === 'linkCard') {
                    state.title = 'Перепривязка карты';
                    state.type = 'linkCard';
                    state.id = modal.data.human.id;
                    state.step = 6;
                }
            }

            socketOn('placeCard', (r) => {
                if (isOpen('human_a_e_modal') && state.step === 6) {
                    if (state.step6.lastCode !== 1) {
                        state.step6.code1 = r.code;
                        state.step6.lastCode = 1;
                    } else {
                        state.step6.code2 = r.code;
                        state.step6.lastCode = 2;
                    }
                }
            });
        }));

        onUnmounted(() => {
            // socketOff('placeCard');
        });

        function onSelectedEntrance(entrance: any) {
            state.step1.entranceId = entrance.id;
        }

        function onSelectedUniversity(university: any) {
            state.step1.prop1 = university.id;
        }

        function onSelectedEducation(education: any) {
            state.step1.prop2 = education.id;
        }

        function onSelectedRole(role: any) {
            state.step1.roleId = role.id;
        }

        function onSelectedInstitution(institution: any) {
            state.step1.prop1 = institution.id;
        }

        function getBody() {
            return jsonToFormData({
                id: state.id,
                firstName: state.step1.firstName,
                lastName: state.step1.lastName,
                middleName: state.step1.middleName,
                iin: state.step1.iin,
                // отправляем как 7XXXXXXXXXX
                phone: normalizedPhoneDigits.value || "",
                entranceId: state.step1.entranceId,
                roleId: state.step1.roleId,
                prop1: state.step1.prop1,
                prop2: state.step1.prop2,
                roomNumber: state.step1.roomNumber,
                courseNumber: state.step1.courseNumber,
                contractNumber: state.step1.contractNumber,
                // @ts-ignore
                contractDate: state.step1.contractDate ? moment(state.step1.contractDate).format('YYYY-MM-DD') : null,
                // @ts-ignore
                enteredAt: state.step1.enteredAt ? moment(state.step1.enteredAt).format('YYYY-MM-DD') : null,
                // file1: state.step5.file1,
                file2: state.step5.file2,
                file3: state.step5.file3,
                rfid: state.step6.code1,
            }, {
                arrayIndexes: true,
                excludeNull: false,
                useDotSeparator: false,
            }, new FormData());
        }

        function formHandler() {
            if (state.step === 1) {
                if (errors.value) {
                    state.step1.visibleErrors = true;
                } else {
                    state.step1.visibleErrors = false;
                    if (state.step1.roleId === 1) {
                        state.step = 5;
                    } else if (skipCardStep.value) {
                        createHuman();
                    } else {
                        state.step = 6;
                    }
                }
            } else if (state.step === 5) {
                if (/* isFile1Error.value || */ isFile2Error.value || isFile3Error.value) {
                    state.step5.visibleErrors = true;
                } else if (state.type === 'add') {
                    if (skipCardStep.value) {
                        createHuman();
                    } else {
                        state.step = 6;
                    }
                } else {
                    api.v1.humans.update(state.id, getBody()).then((r: any) => {
                        modal.ok({
                            human: r.data.data.human,
                        });
                    }).finally(() => state.loader = false);
                }
            } else if (state.step === 6 && !isCodesError.value) {
                if (state.type === 'add') {
                    createHuman();
                } else if (state.type === 'linkCard') {
                    state.loader = true;
                    api.v1.humans.linkCard(state.id, getBody()).then((r: any) => {
                        modal.ok({
                            human: r.data.data.human,
                        });
                    }).finally(() => state.loader = false);
                }
                // createData
            }
            // if (errors.value) {
            //     state.visibleErrors = true;
            // } else {
            //     state.visibleErrors = false;
            //     state.loader = true;
            //     api.v1.turnstiles.create({
            //         name: state.name,
            //         sn: state.sn,
            //         entranceId: state.entranceId,
            //         reverseDirection: state.reverseDirection,
            //     }).then((r: any) => {
            //         modal.ok({
            //             turnstile: r.data.data,
            //         });
            //     }).finally(() => state.loader = false);
            // }
        }

        function createHuman() {
            state.loader = true;
            api.v1.humans.create(getBody()).then((r: any) => {
                modal.ok({
                    human: r.data.data.human,
                });
            })
                .catch((error: any) => {
                    alert(error.response?.data?.message || "Что-то пошло не так. Попробуйте снова.");
                })
                .finally(() => state.loader = false);
        }

        function backStep() {
            // Шаги: 1 — данные, 5 — документы (только студент), 6 — карточка
            if (state.step === 6 && state.step1.roleId === 1) {
                state.step = 5;
            } else {
                state.step = 1;
            }
        }

        watch(() => state.step1.iin, (v) => {
            if (v.length === 12 && /^\d{12}$/.test(v)) {
                api.v1.humans.checkIin(v).then((r: any) => {
                    const data = r.data;

                    if (data.ok) {
                        state.step1.humanExist = false;
                        state.step1.humanExistError = ''; // нет ошибки
                    } else {
                        state.step1.humanExist = true;
                        state.step1.humanExistError = data.message;
                    }

                }).catch((e: any) => {
                    state.step1.humanExist = true;
                    state.step1.humanExistError = e?.response?.data?.message || 'Ошибка проверки ИИН';
                });
            } else {
                // Сбросим, если ИИН невалиден
                state.step1.humanExist = false;
                state.step1.humanExistError = '';
            }
        });


        return {
            errors,
            state,
            entrances,
            universities,
            educations,
            institutions,
            humanRoles,
            humanRolesFiltered,
            moment,
            getInstitution,
            isEntranceIdError,
            isUniversityIdError,
            isInstitutionIdError,
            isEducationIdError,
            isRoleIdError,
            isFirstNameError,
            isLastNameError,
            isIinError,
            isPhoneError,
            isPhoneRequired,
            phoneInvalidFeedback,
            isEnteredAtError,
            isFile1Error,
            isFile2Error,
            isFile3Error,
            isRoomNumberError,
            isCourseNumberError,
            isContractNumberError,
            isContractDateError,
            onSelectedEntrance,
            onSelectedUniversity,
            onSelectedEducation,
            onSelectedInstitution,
            onSelectedRole,
            formHandler,
            backStep,
            selectFile,
            isCodesError,
            file1,
            file2,
            file3,
            isCapacityError,
            isFinalStep,
            isHumanExist,
            isHumanExistError,
            iinInvalidFeedback
        };
    },
});
</script>

<style scoped lang="scss"></style>
